import { useReduxState } from 'hooks';

interface Props {
  description: string;
  title: string;
}

const ProfileCompetencyMappingHeader = ({ description, title }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="header">
      <h2 className="title">{title}</h2>

      <p className="description">{description}</p>

      <style jsx>{`
        .header {
          border-bottom: 1px solid ${theme.lightGrey};
          padding: 15px;
        }
        .title {
          color: ${theme.textColor};
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0;
        }
        .description {
          color: ${theme.textColorLight};
          font-weight: 400;
          font-size: 1.5rem;
          margin: 5px 0 0;
        }
      `}</style>
    </div>
  );
};

export default ProfileCompetencyMappingHeader;
